import React from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import PollEntity from './../../../store/polls-store/poll-entity';
import PollsList from '../polls-list-container/polls-list';
import EmptyList from '../shared/empty-list';
import { NonceCSP } from '../../../constans/common-constants';

interface IProps {
  list: PollEntity[];
  selectPoll: (pollId: string) => void;
  onDragEndHandler: (result: DropResult) => void;
  onDragStartHandler: (result: DropResult) => void;
  toggleManagePollModal: () => void;
  isMobile: boolean;
  isOnePollOpened: boolean;
}

const DraggablePollsList: React.FC<IProps> = ({
  list,
  selectPoll,
  onDragEndHandler,
  onDragStartHandler,
  toggleManagePollModal,
  isMobile,
  isOnePollOpened
}): JSX.Element => {
  const shouldShowEmptyList = isMobile && !list.length;

  return (
    <DragDropContext onDragEnd={onDragEndHandler} onDragStart={onDragStartHandler} nonce={NonceCSP.DND}>
      <div className='list-items'>
        <Droppable droppableId='polls-items'>
          {(provided) => (
            <ul className='polls-list-items' ref={provided.innerRef}>
              <PollsList
                list={list}
                selectPoll={selectPoll}
                isOnePollOpened={isOnePollOpened}
              />
            </ul>
          )}
        </Droppable>
        {shouldShowEmptyList && <EmptyList toggleManagePollModal={toggleManagePollModal}/>}
      </div>
    </DragDropContext>
  );
};

export default DraggablePollsList;
